import { type FileTypeEnum, postApiFilesPresignedUrl } from '@/shared/api'
import axios from 'axios'
import { createEffect } from 'effector'

export const UploadFileType = {
  Image: 1 as FileTypeEnum,
  Track: 2 as FileTypeEnum,
  Document: 3 as FileTypeEnum,
} as const

export const presignedUrlFx = createEffect(postApiFilesPresignedUrl)

export type UploadFileMutationPayload = {
  url: string
  file: File
  onUploadProgress?: (percent: number) => void
}
export const uploadFileToPresignedUrlFx = createEffect({
  handler: async ({
    url,
    file,
    onUploadProgress,
  }: UploadFileMutationPayload) => {
    await axios.put(url, file, {
      headers: { 'Content-Type': file.type },
      onUploadProgress: (progressEvent) => {
        const percent = progressEvent.total
          ? Math.round((progressEvent.loaded / progressEvent.total) * 100)
          : 0
        onUploadProgress?.(percent)
      },
    })
  },
})
